import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { AppWrap } from 'apps/marketplace/components/AppWrap'
import { RouteNotFound } from 'components/404'
import { isUserType } from 'utils/userTypes'
import NewCarrierApplication from '../pages/NewCarrierApplication'
import ActiveShipment from './ActiveShipments'
import Carrier from './Carrier'
import { CarrierSnapshot } from './CarrierLookupForm/CarrierSnapshot'
import CarriersList from './CarriersList'

export const appName = 'carriers'

export function App() {
  const { userDetails } = useUserDetails()
  const { userType = '' } = userDetails || {}
  const isAdmin = isUserType('admin', userType)

  return (
    <div className='carrier-route'>
      <AppWrap appName={appName} title='Carrier Profile'>
        {isAdmin ? (
          <Switch>
            <Route exact path='/' component={CarriersList} />
            <Route exact path='/new/review' component={CarrierSnapshot} />
            <Route exact path='/new' component={NewCarrierApplication} />
            <Route exact path='/edit/:id' component={ActiveShipment} />
            <Route exact path='/:id/:tab?' component={Carrier} />
            <Route component={RouteNotFound} />
          </Switch>
        ) : (
          <Route component={RouteNotFound} />
        )}
      </AppWrap>
    </div>
  )
}
